import {mapState, mapGetters, mapActions} from 'vuex'

export const layoutComputed = {
    ...mapState('layout', {
        layoutType: (state) => state.layout_type,
        layoutWidth: (state) => state.layout_width,
        leftSidebarType: (state) => state.left_sidebar_type,
        topbar: (state) => state.top_bar,
        loader: (state) => state.loader
    })
}
export const authenticationMethods = {
    ...mapActions('authentication', ['login', 'identify', 'register', 'logout']),
    ...mapState('authentication', {
        currentUser: (state) => state.account,
    }),
    ...mapGetters('authentication', ['isLoggedIn']),
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])